import React from 'react';
import {Box} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import WarningIcon from '@mui/icons-material/Warning';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import {VALIDATION} from './BUILDER_VALIDATION';
import {usePlanValidationLevel} from './usePlanValidationLevel';
import {planFormClasses} from './planFormClasses';

interface PlanValidationIconProps {
  formikKeyPrefix: string;
}

export const PlanValidationIcon: React.FC<PlanValidationIconProps> = ({
  formikKeyPrefix,
}) => {
  const {level} = usePlanValidationLevel(formikKeyPrefix);

  if (level === VALIDATION.NA) return null;

  return (
    <Box sx={planFormClasses.validationIcon}>
      {level === VALIDATION.VALID && <CheckIcon />}
      {level === VALIDATION.PARTIALLY_VALID && <WarningIcon />}
      {level === VALIDATION.INVALID && <NotInterestedIcon />}
    </Box>
  );
};
